<template>
  <div class="main">
    <div class="header">
        <!-- 轮播 -->
      <div class="swiper-area">
        <div class="logo">
          <img src="../../assets/logo@3x.png">
        </div>
        <van-swipe :autoplay="5000" style="height:17.5rem" indicator-color="#E82C3A" @change="changeImg" ref="swiper">
          <van-swipe-item v-for="(item,index) in productInfo.colorDetail" :key="index">
            <img :src="item.colorImg">
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 其他颜色 -->
      <div class="color-area">
        <div class="other-color">其他颜色</div>
        <div class="color-img-area">
          <div :class="['color-img',current==index?'red-border':'gray-border']" v-for="(item,index) in productInfo.colorDetail" :key="index" @click="changeColor(index)">
            <img :src="item.colorImg">
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <!-- 名称 -->
      <div class="name-area">
        <div class="name">{{productInfo.productName}}</div>
        <div>{{productInfo.pruductDesc}}</div>
      </div>
    </div>
    <div class="center-area">
      <div class="title">产品信息</div>
      <div style="border: none">
        <table class="table-area">
          <tr>
            <td width="60%">
              <div>产品颜色</div>
              <div>{{(productInfo.colorDetail && productInfo.colorDetail.length>0)?productInfo.colorDetail[current].colorDesc:''}}</div>
            </td>
            <td width="40%">
              <div>产品编码</div>
              <div>{{productInfo.productCode}}</div>
            </td>
          </tr>
          <tr>
            <td width="60%">
              <div>名称</div>
              <div>{{productInfo.productName}}</div>
            </td>
            <td width="40%">
              <div>型号</div>
              <div>{{productInfo.model}}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="product-detail">
      <div class="title">商品详情</div>
      <img :src="productInfo.pruductShowImg">
    </div>
  </div>
</template>
<script>
import {getProductDetail} from '@/apis/product.js'
import {getJsAPI} from '@/apis/weixin'
import wxapi from '@/utils/wxapi'
export default {
  name:'product',
  data(){
    return {
      productInfo:{},
      current:0,
      shareData:{},
      shareOption:{}
    }
  },
  computed:{
    itemId(){
      return this.$route.query.id || null
    }
  },
  methods: {
    _getProductDetail(){
      let params = {
        productId:this.itemId
      }
      getProductDetail(params).then(res=>{
        this.productInfo = res.data
        this.shareOption = {
          title:res.data.productName,
          link:window.location.href,
          imgUrl:res.data.pruductImg,
          desc:'台铃电动车，省电·跑更远！'
        }
        this._getJsAPI()
      })
    },
    changeImg(index){
      this.current = index
    },
    changeColor(index){
      this.current = index
      this.$refs.swiper.swipeTo(index);
    },
    _getJsAPI(){
      let params = {
        url:window.location.href
      }
      getJsAPI(params).then(res=>{
        this.shareData = res.data
        wxapi.wxRegister(this.shareData,this.shareOption)
      })
    }
  },
  created(){
    this._getProductDetail()
  }
}
</script>
<style lang="scss" scoped>
  .main{
    width:100%;
    margin:0;
    padding:0;
    background:#F7F7F7;
    text-align:left;
  }

  .header{
    width:100%;
    background:#FFF;
    padding-bottom:0.75rem;
  }
  .swiper-area{
    width:100%;
    height:17.5rem;
    position: relative;
  }
  .swiper-area .logo{
    position: absolute;
    left:0.875rem;
    top:1rem;
    width:3.4375rem;
  }
  .swiper-area .logo img {
    width:100%;
  }
  .swiper-area video{
    width:100%;
    height:100%;
  }
  .swiper-area img{
    height:100%;
  }
  .swiper-container{
    width:100%;
    height:100%;
  }
  .color-area{
    width:100%;
    margin:0.875rem 0;
  }
  .color-area .other-color{
    display: inline-block;
    width:4.5rem;
    height:2rem;
    line-height: 2rem;
    font-size:0.75rem;
    border-right: 1px solid #F0F0F0;
    text-align:center;
    color:#4D4D4D;
  }
  .color-area .color-img-area{
    width:18.75rem;
    float: right;
  }
  .color-area .color-img{
    width:2rem;
    height:2rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 0.25rem;
    display: inline-block;
    margin-left:0.85rem;
  }
  .color-area .color-img img {
    width:100%;
    height:100%;
  }
  // .price-area{
  //   width:100%;
  //   height:3.75rem;
  //   background:url('./image/price-bg.png') no-repeat;
  //   background-size: 100% 100%;
  //   color:#FFFEFE;
  //   font-size:0.75rem;
  //   padding:0 0.75rem;
  // }
  .line-height{
    height:2rem;
    line-height:2rem;
  }
  .price-area .price-item .left .price{
    font-size:1.33rem;
  }
  .price-area .price-item .left{
    display: inline-block;
  }
  .name-area{
    font-size:0.8125rem;
    color:#666666;
    padding:0 0.75rem;
    margin-top:0.75rem;
  }
  .name-area .name{
    font-size:1.125rem;
    color:#333333;
    font-weight: bold;
  }
  .center-area{
    margin-top:0.67rem;
    background:#FFF;
    padding:1.25rem 0.75rem;
  }
  .table-area{
    width:100%;
  }
  .table-area td{
    border:none;
    border-bottom: 1px solid #F7F7F7;
    height:3.5rem;
  }
  .table-area td div:nth-child(1){
    color:#666666;
    font-size: 0.6875rem;
  }
  .table-area td div:nth-child(2){
    color:#231815;
    font-size: 0.75rem;
  }
  .product-detail{
    margin-top:0.67rem;
    background:#FFF;
    padding:1.25rem 0.75rem;
  }
  .product-detail img{
    width:100%;
    margin-top:0.75rem;
  }
  .title{
    font-size: 1rem;
    color:#231815;
    font-weight: bold;
  }
  .gray-border{
    border-color: #E5E5E5;
  }
  .red-border{
    border-color: #E82C3A;
  }
  .right{
    float:right;
  }
  .center{
    text-align:center;
  }
  .clear{
    clear: both;
  }
</style>